<template>
    <div class="wrap" @click="show = false">
        <car-headerbar v-if="showHeader" :title="$store.state.createTemplateTitle || '创建呱呱问卷'" :isCustomLeft="isCustomLeft"/>
        <form action="/" class="form-search">
            <me-search
                ref="search"
                v-model="condition"
                show-action
                :placeholder="placeholder"
                @search="onSearch"
                @focus="onFocus"
                @input="onInput"
                @clear="onClear">
                <template #action>
                </template>
            </me-search>
            <div class="labels" :class="{show}">
                <span class="text">标签：</span>
                <div class="label_tabs">
                  <me-tabs :tab-scroll-offset="0" :ellipsis="false" swipe-threshold="2" v-model="active" @change="(data) => selectLabel(data)">
                    <me-tab title="全部" name="" @click="selectLabel({labelName: '', id: ''})">
                    </me-tab>
                    <me-tab v-for="(item, index) in labels" :title="item.labelName" :key="index" :name="item.id" @click="selectLabel(item)">
                    </me-tab>
                  </me-tabs>
                </div>
                <me-icon :name="show ? 'arrow-up' : 'arrow-down'" class="more" @click.stop="show=!show"/>
            </div>
            <div v-show="labels.length > 0 && show" class="tabs_all">
                <div class="tag_item">
                  <me-tag
                      type="primary"
                      size="large"
                      v-for="(item, index) in labels"
                      :key="index"
                      :color="item.id === labelId ? '#05B555' : '#F2F4F6'"
                      :text-color="item.id === labelId ? '#fff' : '#424B58'"
                      class="tag"
                      @click="selectLabel(item)">{{ item.labelName }}</me-tag>
                </div>
            </div>
        </form>
        <mescroll-vue class="guagua" :class="{showHeader: !showHeader && !isGuaGua}" ref="mescroll" :up="mescrollUp" @init="mescrollInit">
            <me-list
              v-if="list.length > 0"
              v-model="pullLoading"
              :finished="finished"
              :offset="10"
              finished-text=""
              @load="getList"
            >
              <div class="card" v-for="(item) in list" :key="item.pageId" @click="openSheet(item)" >
                <div class="main">
                    <div class="title">{{item.pageTempName}}</div>
                    <div class="content">
                      <p class="Published">
                        <span>{{item.isCreator || myLabel ? '创建人：' : '分享人：'}}</span>{{ item.createdByName }}
                      </p>
                    </div>
                </div>
                <div class="main_content">
                  <div class="content_num">{{item.questionNum}}</div>
                  <div class="content_text">{{'题数'}}</div>
                </div>
              </div>
            </me-list>
            <div class="empty-content" v-else>
              <template v-if="!isEmpty">
                <div v-if="isFirst">
                  <img src="@assets/images/empty_question.png" alt="" />
                  <p>暂无更多数据！</p>
                </div>
              </template>
  
              <div v-else>
                <img src="@assets/images/empty_question.png" alt="" />
                <p>很抱歉，没有找到相关问卷模板！</p>
              </div>
            </div>
        </mescroll-vue>
        <template-card
          :sheetShow="sheetShow"
          :myLabel="myLabel"
          @cancel ="sheetShow = false"
          :row="row"
          :tid="tid"
          @deleteTem="deleteTem"
        ></template-card>
    </div>
  </template>
  <script>
  import { Toast } from '@guazi-fe/melon'
  import { Questionnaire } from '@/network'
  import { mixin } from '@/mixins'
  // import { off as offStatus } from '@/util/status-util'
  import { addClass2, removeClass2 } from '@/util/status-util'
  import Card from '../../compontents/card.vue'
  import TemplateCard from '../../compontents/templateCard.vue'
  import MescrollVue from 'mescroll.js/mescroll.vue'
  import browser from '@/util/browser'
  
  export default {
      name: 'createTemplate',
      data() {
          return {
              active: '',
              placeholder: '搜索问卷模板',
              isLoading: false,
              condition: '',
              isEmpty: false,
              createBtnShow: true,
              createSheetShow: false,
              sheetShow: false,
              list: [],
              pullLoading: false,
              finished: false,
              refreshing: false,
              pageNum: 1,
              pageSize: 20,
              curItem: {},
              isFirst: false,
              mescroll: null,
              // mescrollDown: {},
              mescrollUp: {
                callback: this.upCallback,
                empty: {
                  tip: '暂无相关数据~'
                },
                htmlNodata: '<p class="upwarp-nodata"> 没有更多了~ </p>'
              },
              isGuaGua: true,
              labels: [],
              labelId: '',
              show: false,
              isCustomLeft: false,
              row: {}
          }
      },
      components: {
          Card,
          MescrollVue,
          TemplateCard,
      },
      props: {
        showHeader: {
          type: Boolean,
          default: true
        },
        myLabel: {
          type: Boolean,
          default: false
        },
      },
      mixins: [mixin],
      created() {
          // this.getList()
          addClass2('body', 'loading')
          const { guaguaApp } = browser
          this.isGuaGua = guaguaApp
          this.isCustomLeft = guaguaApp
          this.getTemplateLabel()
      },
      methods: {
          deleteTem(pageTempId) {
            const options = {
              title: '提示',
              message: '您确定要删除这个模版吗？',
              confirmFn: () => {
                  addClass2('body', 'loading')
                  let data = {
                    tid: this.tid,
                    pageTempId: pageTempId
                  }
                  Questionnaire.deleteTemplate(data).then((res) => {
                    removeClass2('body', 'loading')
                    const { code, data } = res.data
                    if (code == 'S00000') {
                      Toast.success('删除成功')
                      this.sheetShow = false
                      let index = this.list.findIndex(item => item.pageTempId === pageTempId)
                      this.list.splice(index, 1)
                      this.row = {}
                    } else {
                      Toast.fail(data)
                    }
                  }).catch((error) => {
                      removeClass2('body', 'loading')
                      Toast.fail(error.response.data.message)
                      console.error(error)
                  })
              },
            }
            this.$_dialog(options)
          },
          getTemplateLabel() {
            let params = {
              tid: this.tid,
              labelName: ''
            }
            if (this.myLabel) {
              params.myLabel = this.myLabel
            }
            Questionnaire.getTemplateLabel(params).then((res)=> {
              this.labels = res.data.data
            })
          },
          selectLabel(tag) {
            this.show = false
            this.labelId = tag.id || tag
            if (tag.id) {
              this.active = tag.id
            }
            this.onSearch()
          },
          mescrollInit (mescroll) {
            this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
          },
          upCallback(page, mescroll) {
            this.pageNum = page.num
            this.getList(mescroll)
          },
          getList(mescroll) {
              // addClass2('body', 'loading')
              removeClass2('body', 'loading')
              // 重置
              this.isEmpty = false
              if (!this.condition) {
                  this.createBtnShow = true
              }
              if (this.refreshing) {
                  this.list = []
                  this.refreshing = false
              }
              const data = {
                  tid: this.tid,
                  query: this.condition,
                  labelId: this.labelId,
                  lableId: this.lableId,
                  pageSize: this.pageSize,
                  pageNum: this.pageNum,
              }
              if (this.myLabel) {
                data.myTemplate = this.myLabel
              }
              Questionnaire.templateList(data).then((res) => {
                  // offStatus('loading')
                  // removeClass2('body', 'loading')
                  this.pullLoading = false
                  this.finished = true
                  const { code, data } = res.data
                  if (code == 'S00000') {
                      this.isFirst = false
                      if (data.list.length && data.list.length) {
                          this.list = this.pageNum === 1 ? [...res.data.data.list] : [...this.list, ...res.data.data.list]
                      } else {
                          // condition 不为空 且 list为空
                          if (this.condition) {
                              this.isEmpty = true
                          } else {
                              this.isFirst = true
                          }
                      }
                      if(!mescroll) return
                      this.$nextTick(() => {
                        mescroll.endSuccess(data.list.length)
                      })
                  }
                  // $CA.util.NativeAPI.invoke('hiddenCloseBtn',{"hiddenClose":"1"})
  
              }).catch((error) => {
                  removeClass2('body', 'loading')
                  Toast.fail(error.response.data.message)
                  this.pullLoading = false
                  console.error(error)
              })
  
          },
          deleteItem(item) {
              for (let index = 0; index < this.list.length; index++) {
                  const element = this.list[index]
                  if (item == element.pageId) {
                      this.list.splice(index, 1)
                  }
              }
          },
          onRefresh() {
              this.finished = false
              // 将 pullLoading 设置为 true，表示处于加载状态
              this.pullLoading = true
              // 清空数据
              this.refreshing = true
              this.sheetShow = false
              this.pageNum = 1
              this.getList()
          },
          // 面板操作
          openSheet(item) {
            this.sheetShow = true
            this.row = { ...item }
          },
          //
          onSearch() {
              this.refreshing = true
              this.mescroll.resetUpScroll(true)
              // this.getList()
          },
          onCreate() {
              this.createSheetShow = true
          },
          onCancel() {
              this.sheetShow = false
          },
          cancelSearch() {
              this.createBtnShow = true
              this.onSearch()
          },
          onFocus() {
              this.createBtnShow = false
          },
          // onBlur() {
          //     this.createBtnShow = true
          // },
          onClear() {},
          onInput() {
              this.createBtnShow = false
          },
      },
  }
  </script>
  <style lang="scss" scoped>
    .showHeader {
      top: 4.8rem !important; 
    }
    .label_tabs {
      width: calc(100% - 60px);
      height: 38px;
    }
    ::v-deep .me-tabs--line .me-tabs__wrap {
        height: 38px;
    }

    ::v-deep .me-tab--active {
      font-size: 14px;
      color: #05B555;;
      font-weight: 400;
    }
    ::v-deep .me-tab__text {
      font-size: 14px;
      font-weight: 400;
    }
    ::v-deep .me-tabs__nav--complete {
      padding-right: 0;
      padding-left: 0;
    }
    .tabs_all {
      border-top: 1px solid #F2F4F6;
      padding-bottom: 20px;
      background: #fff;
      max-height: 282px;
      overflow-y: scroll;
    }
    .tag {
      margin-top: 16px;
      margin-left: 16px;
      padding: 10px 16px;
      color: #424B58;
      font-size: 14px;
    }
  .wrap{
    height: 100%;
    .form-search{
      position: fixed;
      z-index: 1;
      width: 100%;
    }
    .labels{
        display: flex;
        align-items: center;
        padding: 0 12px 0px;
        background: #fff;
        .text{
            display: inline-block;
            width: 44px;
            font-size: 14px;
        }
        .more {
          margin-left: 5px;
        }
        .more{
            display: inline-block;
            width: 12px;
            margin-top: 5px;
        }
    }
    .mescroll{
      position: fixed;
      top: 2.6rem;
      bottom: 0;
      height: auto;
      &.guagua{
        top: 3.6rem;
      }
    }
    .create-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #06B455;
      border-radius: 6px;
    }
    .me-pull-refresh{
      min-height: calc(100vh - 100px);
    }
    .me-list{
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .card{
      display: flex;
      justify-content: space-between;
      width: 95%;
      margin-left: 2.5%;
      margin-right: 2.5%;
      margin-top: 10px;
      background: white;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 25px 0px 25px 23px;
      color: #9298A8;
      .main_content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 94px;
        border-left: 1px solid #F2F4F6;
      }
      .content_num {
        font-weight: 600;
        font-size: 20px;
        color: #06B455;
        line-height: 28px;
      }
      .main{
        .title{
          height: 22px;
          font-size: 14px;
          font-weight: bold;
          color: #333;
          width: 100%;
          line-height: 28px;
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .content{
            margin: 8px 0 0;
          p{
            margin: 0;
          }
          .Published,
          .Unpublished {
            height: 24px;
            line-height: 24px;
            border-radius: 4px;
            font-size: 12px;
          }
        }
      }
      .right{
        padding-left: 15px;
        width: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title{
          text-align: center;
          font-size: 13px;
          color: #9298A8;
          .Published,
          .Unpublished {
            font-size: 20px;
            color: #06B455;
          }
          .Unpublished{
            color: #5F6670;
          }
        }
        .content{
          margin-top: 8px;
          text-align: center;
        }
      }
  
    }
  
    .empty-content{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      font-size: 14px;
      font-weight: bold;
      color: #333;
      width: 216px;
      height: 212px;
      text-align: center;
      img{
        width:100%;
      }
      .sub {
          font-size: 12px;
          font-weight: normal;
          color: #9298A8;
      }
    }
  }
  
  </style>
  
  